import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'automationOnHold/<templateId>/contact';

export function useAutomationOnHoldContactsQuery({
	templateId,
	includeAll,
	pageSize = 25,
	totalCount = 0,
	enabled = true,
	impersonationContext,
}: {
	templateId: string;
	includeAll?: boolean;
	pageSize?: number;
	totalCount?: number;
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
}) {
	const userSession = useUserSession();

	const queryParams: Record<string, boolean | number> = {};

	if (includeAll) {
		queryParams.includeAll = includeAll;
		queryParams.pageSize = 0;
		queryParams.totalCount = 0;
	} else {
		queryParams.pageSize = pageSize;
		queryParams.totalCount = totalCount;
	}

	return useQuery({
		enabled,
		queryFn: async () => {
			const response = await userSession.webServiceHelper.callAsync<
				Api.IContact[] | { values: Api.IContact[]; pageToken?: string }
			>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `automationOnHold/${encodeURIComponent(templateId)}/contact`,
					queryParams: Object.keys(queryParams).length > 0 ? queryParams : undefined,
					impersonationContext,
				}),
				'GET'
			);
			// API may return paginated response with values array or direct array
			return Array.isArray(response) ? response : response.values || [];
		},
		queryKey: [BASE_QUERY_KEY, templateId, includeAll, pageSize, totalCount, impersonationContext?.account?.id],
	});
}

export function invalidateAllAutomationOnHoldContactsQueries() {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
}
